import { checkHasAnyRoleOrPermission } from 'constants/permission';
import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';

const PrivateRouter = ({ children, permissions, roles, element, ...props }) => {
  const {
    isAuthenticated,
    permissions: permissionsList,
    roles: roleList,
  } = useSelector((state) => state.auth);
  const { pathname } = useLocation();

  if (isAuthenticated) {
    if (
      checkHasAnyRoleOrPermission(permissionsList, roleList, roles, permissions)
    ) {
      return element;
    }

    return <Navigate to="/forbidden" replace />;
  }

  return <Navigate to="/auth/login" state={{ from: pathname }} />;
};

export default PrivateRouter;
